import { Injectable } from '@angular/core';

import {
	TableViewCreateBody,
	TableViewUpdateBody,
} from '@reach/interfaces/table-views/table-view.interface';
import {
	CreateTableViewResponseType,
	GetTableViewsResponseType,
	UpdateTableViewResponseType,
} from '@reach/interfaces/table-views/table-view.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class TableViewsApiService extends BaseApiService {
	protected commonPath = ['users', 'me', 'table-views'];

	public async getTableViews(): Promise<GetTableViewsResponseType> {
		return await this.http.get<GetTableViewsResponseType>(this.url(''));
	}

	public async createTableView(dto: TableViewCreateBody): Promise<CreateTableViewResponseType> {
		return await this.http.post<CreateTableViewResponseType>(this.url(''), dto);
	}

	public async deleteTableView(tableViewId: string): Promise<void> {
		return await this.http.delete<void>(this.url(tableViewId));
	}

	public async updateTableView(
		tableViewId: string,
		dto: TableViewUpdateBody
	): Promise<UpdateTableViewResponseType> {
		return await this.http.put<UpdateTableViewResponseType>(this.url(tableViewId), dto);
	}
}
